<template>
  <div class="todo-add-professional-rating">
    <el-row type="flex">
      <el-col>
          <el-divider />
            <template>
              <el-form :model="addReviewForm" ref="addReviewForm" v-loading="loading">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="Select Service Provider" :rules="[{required: true}]">
                      <el-select v-model="addReviewForm.serviceProvider" placeholder="Select Service Provider" filterable>
                        <el-option
                          v-for="item in getServicePList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">{{item.name}} ({{item.email}})
                        </el-option>
                      </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Customer Name" :rules="[{required: true}]">
                      <el-input placeholder="Enter Customer Name" v-model="addReviewForm.customerName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                      <el-form-item label="Rating" :rules="[{required: true}]">
                      <el-rate v-model="addReviewForm.rating"></el-rate>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                      <el-form-item label="Review" :rules="[{required: true}]">
                      <el-input type="textarea" :rows="4" placeholder="Review comment" v-model="addReviewForm.review"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <el-form-item class="form-buttons">
                      <el-button type="primary" @click="onSubmit(addReviewForm)">Submit</el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item class="form-buttons">
                      <el-button @click="onClear(addReviewForm)">Cancel</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </template>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getServiceProviders, saveReview } from '@/api/visibility'
  export default {
    name: 'Visibility',
    props: {
    },
    components: {
    },
    data() {
      return {
        loading: true,
        addReviewForm: {
          serviceProvider: '',
          customerName: '',
          rating: '',
          review: ''
        },
        getServiceIndustryList: [],
        getServicePList: [],
        getPinnedProfessionalsList: []
      }
    },
    created: function() {
      this.getServiceProviderListFunc()
    },
    methods: {
      async getServiceProviderListFunc() {
        try {
          const { data } = await getServiceProviders()
          this.getServicePList = data
          this.getServicePList.sort(function(a, b) {
              const aa = (a.name === null || a.name === undefined) ? '' : a.name.toLowerCase()
              const bb = (b.name === null || a.name === undefined) ? '' : b.name.toLowerCase()
              return aa > bb ? 1 : bb > aa ? -1 : 0
          })
        } catch (err) {
        }
        this.loading = false
      },
      onSubmit() {
        this.saveReviewFunc(this.addReviewForm)
      },
      async saveReviewFunc(formData) {
        this.loading = true
        try {
          const { data } = await saveReview(formData)
          this.onClear()
        } catch (err) {
        }
        this.loading = false
      },
      onClear() {
        this.addReviewForm.serviceProvider = ''
        this.addReviewForm.customerName = ''
        this.addReviewForm.rating = ''
        this.addReviewForm.review = ''
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/variables';

  .form-buttons{
    margin-right: 5px;
  }

  .el-collapse-item .is-active {
    background-color: #e9e6e3;
  }
  .el-form{
    margin-top: 20px;
  }
  .el-collapse-item .el-collapse-item__header{
    padding-left: 5px;
  }
</style>
